module.exports = __webpack_public_path__ + "img/bj.772850e8.svg";